import { PAYMENT_STATUS_LABEL, PAYMENT_STATUS_TONE } from '../../Enums/stripe-status.enum';
import {
  PaymentInvoiceRefResponse,
  PaymentSummaryResponse,
} from '../../Interfaces/api/backoffice/billing-document.interface';
import { StatusTone } from '../../Modules/Shared/Types/status-tone.type';

export class PaymentSummary {
  id = '';
  stripe_payment_intent_id: string | null = null;
  stripe_charge_id: string | null = null;
  stripe_status = '';
  amount: number | null = null;
  currency: string | null = null;
  failure_code: string | null = null;
  failure_message: string | null = null;
  paid_at: string | null = null;
  created_at: string | null = null;
  is_retryable = false;
  refunded_amount = 0;
  refundable_remainder = 0;
  invoice: PaymentInvoiceRefResponse | null = null;

  constructor(data: Partial<PaymentSummaryResponse> = {}) {
    Object.assign(this, data);
  }

  get statusLabelKey(): string {
    return PAYMENT_STATUS_LABEL[this.stripe_status] ?? this.stripe_status;
  }

  get statusTone(): StatusTone {
    return PAYMENT_STATUS_TONE[this.stripe_status] ?? 'neutral';
  }

  get hasFailure(): boolean {
    return this.failure_code !== null || this.failure_message !== null;
  }

  get isRefundable(): boolean {
    return this.refundable_remainder > 0;
  }
}
